import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
	Icon,
	Image
} from 'semantic-ui-react';

const Photo = ( { photoUri } ) => {
	return (
		<div>
			{ photoUri
				? <Image
					centered
					circular
					fluid
					src={ photoUri
						? photoUri
						: 'https://react.semantic-ui.com/images/wireframe/image.png' }
					style={ {
						aspectRatio: 1,
						width: '30px'
					} }
				/>
				: <Icon
					fitted
					name="user circle"
					style={ {
						display: 'block',
						lineHeight: 1,
						fontSize: '30px'
					} }
				/>
			}
		</div>
	);
};

Photo.propTypes = { photoUri: PropTypes.string };

export default memo( Photo );
